class WebSocketService {
  constructor(url) {
    this.url = url;
    this.socket = null;
    this.queue = [];
    this.isConnected = false;
    this.reconnectInterval = 3000; // Retry every 3 seconds
    this.connect();
  }

  connect() {
    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      console.log("WebSocket connected");
      this.isConnected = true;
      this.queue.forEach((msg) => this.send(msg));
      this.queue = [];
    };

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("Received:", data);
      if (this.onMessageCallback) this.onMessageCallback(data);
    };

    this.socket.onclose = () => {
      console.log("WebSocket disconnected. Reconnecting in 3 seconds...");
      this.isConnected = false;
      setTimeout(() => this.connect(), this.reconnectInterval);
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      this.socket.close(); // Close the socket to trigger reconnection
    };
  }

  send(message) {
    if (this.isConnected) {
      this.socket.send(JSON.stringify(message));
    } else {
      this.queue.push(message);
    }
  }

  onMessage(callback) {
    this.onMessageCallback = callback;
  }

  close() {
    if (this.socket) {
      this.socket.onclose = null; // Prevent auto-reconnect on manual close
      this.socket.close();
      console.log("WebSocket manually closed");
    }
  }
}

const webSocketService = new WebSocketService("wss://eastrdytfygjh-bark.hf.space/ws");
export default webSocketService;
